function t(t,n,r){return void 0===(t=(n.split?n.split("."):n).reduce(function(t,n){return t&&t[n]},t))?r:t}function n(t,n,r,e){return(n=n.split?n.split("."):n).slice(0,-1).reduce(function(t,n){return t[n]=t[n]||{}},t)[n.pop()]=r,t}export{t as get,n as set};
//# sourceMappingURL=shvl.es.js.map



//////////////////
// WEBPACK FOOTER
// ./~/shvl/dist/shvl.es.js
// module id = kgun
// module chunks = 1